import { startCase } from "lodash-es";

import { isCamelCase } from "./isCamelCase";

const getServiceLineName = (name) => {
  if (name === "common") {
    return "";
  }

  if (name) {
    if (isCamelCase(name)) {
      return startCase(name);
    } else {
      return name.toUpperCase();
    }
  }

  return "";
};

export default getServiceLineName;
